module.exports = __webpack_public_path__ + "img/bti-logo.cebc50f0.png";